/**
 * Settings → Tax report (TMMAPP-0111; the tmm-api spec review's amendment, MM-D-127): the global
 * tax report — every readable virtual account — through the C2 range dialog, which opens on the
 * year to date. The virtual account menu offers the same report for one virtual account.
 */
import { useState } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DownloadRangeDialog } from '@/features/virtualAccount/DownloadRangeDialog';
import type { SettingsNotify } from './settingsHref';

export function TaxReportSection({ onNotify }: { onNotify: SettingsNotify }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <Stack sx={{ gap: 1.5, alignItems: 'flex-start' }}>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {t('settings.taxReport.body')}
      </Typography>
      <Button variant="outlined" onClick={() => setOpen(true)}>
        {t('virtualAccount.menu.downloadTax')}
      </Button>
      {open && (
        <DownloadRangeDialog
          kind="tax"
          virtualAccount={null}
          onClose={() => setOpen(false)}
          onNotify={(message, options) => onNotify(message, options?.severity)}
        />
      )}
    </Stack>
  );
}
